export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/ob-step-5.png?d8c053004b9e67f6b6bb68cbbb5f0754";